import { render, staticRenderFns } from "./TelnyxChannelDetail.vue?vue&type=template&id=c81d34ac&scoped=true"
import script from "./TelnyxChannelDetail.vue?vue&type=script&lang=js"
export * from "./TelnyxChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./TelnyxChannelDetail.vue?vue&type=style&index=0&id=c81d34ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d34ac",
  null
  
)

export default component.exports